import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

import { GivingAccount } from 'generated/graphql';
import { currencyFormat, CurrencyCode } from 'utils/currencyFormat';
import { brand, brandDarkened } from 'utils/color-styles';
import { selectUser } from 'entities/user/selectors';
import Img from 'retired/Img';
import currencyUSD from 'assets/budgetLedger/currencyUSD.avif';
import currencyEUR from 'assets/budgetLedger/currencyEUR.avif';
import currencyGBP from 'assets/budgetLedger/currencyGBP.avif';
import { renderGivingAccountName } from 'containers/GivingAccountPage/renderGivingAccountName';

const currencySVG: { [currencyCode: string]: string } = {
  USD: currencyUSD as unknown as string,
  EUR: currencyEUR as unknown as string,
  GBP: currencyGBP as unknown as string,
};

const useStyles = makeStyles({
  root: {
    backgroundColor: brand,
    color: 'white',
    padding: '24px',
    flexGrow: 1,
    transition: 'opacity .3s ease-out',
    '&:hover': {
      opacity: 0.9,
    },
  },
  imageBackdrop: {
    backgroundColor: brandDarkened,
    borderRadius: 10,
    textAlign: 'center',
  },
  imageWrapper: { padding: 10 },
  image: { width: '100%', objectFit: 'contain', height: 115 },
  content: { paddingTop: 24, paddingLeft: 10, paddingRight: 10 },
  heading: {
    fontSize: 36,
    fontWeight: 'bold',
    letterSpacing: '-0.3px',
  },
});

export default function GivingAccountCard({
  givingAccount,
}: {
  givingAccount: Pick<
    GivingAccount,
    'id' | 'name' | 'currencyCode' | 'balance' | 'balanceUserCurrency' | 'provider'
  > | null;
}) {
  const user = useSelector(selectUser);
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <div className={classes.imageBackdrop}>
        <div className={classes.imageWrapper}>
          <Img
            src={currencySVG[givingAccount?.currencyCode || 'USD']}
            className={classes.image}
            alt={givingAccount?.currencyCode || 'USD'}
          />
        </div>
      </div>
      <div className={classes.content}>
        <Typography variant="body1">{renderGivingAccountName(givingAccount)}</Typography>
        <Typography className={classes.heading}>
          {givingAccount?.balance
            ? currencyFormat(givingAccount.balance, givingAccount.currencyCode as CurrencyCode)
            : '-'}
        </Typography>
        {user &&
          givingAccount?.balanceUserCurrency &&
          user.displayCurrency !== givingAccount?.currencyCode && (
            <Typography variant="body2">
              {currencyFormat(givingAccount.balanceUserCurrency, user.displayCurrency)}
            </Typography>
          )}
      </div>
    </Paper>
  );
}
